export default __webpack_public_path__ + "static/header@2x-1e542bbecdf67c4b3e421f06e1a30b87.png";